import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';

GoogleAnalytics.initialize(window.config.REACT_APP_GOOGLE_ANALYTICS_KEY);

const withAnalytics = (WrappedComponent, options = {}) => {
  const trackPage = ({ pathname, search }) => {
    const page = pathname + search;
    GoogleAnalytics.set({
      page,
      ...options
    });
    GoogleAnalytics.pageview(page);
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location;
      trackPage(page);
    }

    componentDidUpdate(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export const logEvent = (category, action, label, value, nonInteraction) => {
  GoogleAnalytics.event({
    category,
    action,
    label,
    value,
    nonInteraction
  });
};

/* Analytics Events constants */
/* Categories */
export const ONBOARDING = 'Onboarding';

/* Actions */
export const NEXT = 'Next';
export const PREVIOUS = 'Previous';
export const CONTINUE = 'Continue';
export const START = 'Start';
export const SKIP = 'Skip';
export const COMPLETE = 'Complete';

export default withAnalytics;



// WEBPACK FOOTER //
// ./src/lib/analytics.js